/* Seven Moods — Entrupy certificate add-on */
(function () {
  'use strict';
  if (window.__entrupyAddon) return;
  window.__entrupyAddon = true;

  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function certificateLine(el) {
    return {
      id: Number(el.dataset.addonVariant),
      quantity: 1,
      properties: {
        For: el.dataset.forTitle,
        _for_product: el.dataset.forProduct
      }
    };
  }

  /* 1. Product page: when the box is ticked, add the bag + certificate together.
        Runs in the capture phase so it takes over from the theme's AddToCart handler
        only when the add-on is selected. */
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.product-form')) return;
    const box = document.querySelector('[data-addon-checkbox]');
    if (!box || !box.checked || box.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const btn = form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;
    const originalText = btn ? btn.textContent.trim() : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    try {
      const fd = new FormData(form);
      const items = [
        { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) },
        certificateLine(box)
      ];
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }

      box.disabled = true;
      const note = document.querySelector('[data-addon-note]');
      if (note) note.textContent = 'Added to your bag with this item.';
      box.closest('.entrupy-addon')?.classList.add('is-added');

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: await getCart() }));

      if (btn) {
        btn.textContent = '✓ Added';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2200);
      }
    } catch (err) {
      console.error(err);
      if (btn) {
        btn.textContent = 'Error — try again';
        btn.style.background = '#c0392b';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.style.background = '';
        }, 2500);
      }
    }
  }, true);

  /* 2. Cart drawer + cart page: "Add +$15" buttons next to each bag. */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-entrupy-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ items: [certificateLine(btn)] })
      });
      if (!res.ok) throw new Error('Could not add certificate');

      if (btn.closest('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: await getCart() }));
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
      btn.textContent = 'Try again';
      btn.disabled = false;
    }
  });

  /* 3. If a bag is removed, remove its certificate too. */
  let cleaning = false;
  async function removeOrphans() {
    if (cleaning) return;
    const keys = new Set();
    document.querySelectorAll('[data-entrupy-orphans]').forEach(el => {
      (el.dataset.entrupyOrphans || '').split(',').filter(Boolean).forEach(k => keys.add(k));
    });
    if (!keys.size) return;

    cleaning = true;
    try {
      const updates = {};
      keys.forEach(k => { updates[k] = 0; });
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ updates })
      });
      const cart = await res.json();
      document.querySelectorAll('[data-entrupy-orphans]').forEach(el => { el.dataset.entrupyOrphans = ''; });

      if (document.querySelector('.cart-page')) {
        window.location.reload();
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refreshContents === 'function') {
        drawer.updateCount(cart.item_count);
        await drawer.refreshContents();
      }
    } catch (err) {
      console.warn('Entrupy add-on cleanup failed:', err);
    } finally {
      cleaning = false;
    }
  }

  function init() {
    removeOrphans();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(() => removeOrphans()).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
